import React, { Fragment } from "react";
import { IC } from "../../../resources/Assets";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import { BackgroundDiv, ContentBody, HeaderTitle } from "./ReceiptStyle";

export default (props) => {
  const { setPageIdx, moveUrl } = props;
  const iframeStyle = {
    width: "100%",
    height: "90vh",
    border: "0px",
  };

  return (
    <Fragment>
      <ScrollToTop />
      <BackgroundDiv>
        <HeaderTitle>
          <div style={{ width: "40px", height: "40px" }} onClick={() => setPageIdx(5)}>
            {/* <img src={ArrowLeft} /> */}
            <img src={IC.etc.ICON_CHEVRON_LEFT} />
          </div>
          <div>카드 등록</div>
          <div style={{ width: "40px", height: "40px" }}>{/* <img src={ArrowLeft} /> */}</div>
        </HeaderTitle>

        <ContentBody style={{ padding: "0", marginTop: "0" }}>
          <iframe style={iframeStyle} src={moveUrl} />
        </ContentBody>
      </BackgroundDiv>
    </Fragment>
  );
};
